// src/api.js
import axios from "axios";

// Single source of truth for your API base
export const API_BASE =
  process.env.REACT_APP_API_BASE || "http://localhost:5000";

// Default axios client used everywhere
const api = axios.create({
  baseURL: API_BASE,
});

export default api;

// Named helpers for files that import { postJSON } or { getJSON }
export async function postJSON(path, body) {
  const { data } = await api.post(path, body);
  return data;
}

export async function getJSON(path, params = {}) {
  const { data } = await api.get(path, { params });
  return data;
}

export async function putJSON(path, body) {
  const { data } = await api.put(path, body);
  return data;
}

export async function deleteJSON(path, params = {}) {
  const { data } = await api.delete(path, { params });
  return data;
}
